export default __webpack_public_path__ + "static/horizontal-514c307afab1d9f2054b330a83e04f7b.png";